import { render, staticRenderFns } from "./video.vue?vue&type=template&id=62162a80"
import script from "./video.vue?vue&type=script&lang=js"
export * from "./video.vue?vue&type=script&lang=js"
import style1 from "./video.vue?vue&type=style&index=1&id=62162a80&prod&lang=scss"
import style2 from "./video.vue?vue&type=style&index=2&id=62162a80&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports